(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // ── Search ──────────────────────────────────────────────
  const searchEl  = document.getElementById('header-search');
  const toggleBtn = document.getElementById('search-toggle');
  const inputEl   = document.getElementById('search-input');
  const resultsEl = document.getElementById('search-results');

  // Dedupe Shopify dynamic loading
  if (searchEl.dataset.listenerAttached) return;
  searchEl.dataset.listenerAttached = '1';


  function open() {
    searchEl.classList.add('header__search--active');
    inputEl.focus();
  }

  function close() {
    searchEl.classList.remove('header__search--active');
    inputEl.value = '';
    hideResults();
  }

  function hideResults() {
    resultsEl.classList.remove('header__search-results--visible');
    resultsEl.innerHTML = '';
  }

  function navigate(q) {
    window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
  }

  inputEl.addEventListener('click', event => {
    console.log(searchEl.classList)
    if (!searchEl.classList.contains('header__search--active')) {
      open();
    } else if (inputEl.value.trim()) {
      navigate(inputEl.value.trim());
    } else {
      close();
    }
  });

  inputEl.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && inputEl.value.trim()) navigate(inputEl.value.trim());
    if (e.key === 'Escape') close();
  });

  document.addEventListener('click', (e) => {
    if (!searchEl.contains(e.target)) close();
  });

  let debounce;
  inputEl.addEventListener('input', () => {
    clearTimeout(debounce);
    const q = inputEl.value.trim();
    if (!q) { hideResults(); return; }
    debounce = setTimeout(() => fetchSuggestions(q), 250);
  });

  async function fetchSuggestions(q) {
    searchEl.classList.add('header__search--loading');
    try {
      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`
      );
      const data = await res.json();
      const products = data?.resources?.results?.products || [];
      renderResults(products);
    }
    catch {
      hideResults();
    }
    finally {
      searchEl.classList.remove('header__search--loading');
    }
  }

  function renderResults(products) {
    const noResultsText = searchEl.dataset.noResults;

    if (!products.length) {
      resultsEl.innerHTML = `<div class="search-result search-result--empty">${noResultsText}</div>`;
      resultsEl.classList.add('header__search-results--visible');
      return;
    }
    resultsEl.innerHTML = products.map(p => {
      const img = p.featured_image?.url
        ? `<img class="search-result__img" src="${p.featured_image.url}&width=80" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy">`
        : `<div class="search-result__img search-result__img--placeholder"></div>`;

      let price = p.price_min != null ? p.price_min + 'kr' : '';
      if (price && p.price_max != null && p.price_max != p.price_min) {
        price = 'Från ' + price;
      }

      return `<a class="search-result" href="${p.url}">
        ${img}
        <div class="search-result__info">
          <div class="search-result__title">${p.title}</div>
          ${price ? `<div class="search-result__price">${price}</div>` : ''}
        </div>
      </a>`;
    }).join('');
    resultsEl.classList.add('header__search-results--visible');
  }

  // ── Mobile nav ──────────────────────────────────────────
  const navToggle = document.getElementById('nav-toggle');
  const header    = document.querySelector('header');
  const nav       = document.getElementById('header-menu');

  function openNav() {
    header.classList.add('header--nav-open');
    navToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    header.classList.remove('header--nav-open');
    navToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  navToggle?.addEventListener('click', () => {
    header.classList.contains('header--nav-open') ? closeNav() : openNav();
  });

  nav?.addEventListener('click', (e) => {
    if (e.target.closest('a')) closeNav();
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const product = document.querySelector('.product');
  if (!product || product.dataset.initialized) return;
  product.dataset.initialized = 'true';

  // Gallery
  const side = product.querySelector('.product__image-side');
  const slides = side ? Array.from(side.querySelectorAll('.product__gallery-slide')) : [];
  if (slides.length > 1) {
    let current = 0;
    const goTo = (index) => {
      slides[current].classList.remove('product__gallery-slide--active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('product__gallery-slide--active');
    };
    side.querySelector('.product__gallery-btn--prev')?.addEventListener('click', () => goTo(current - 1));
    side.querySelector('.product__gallery-btn--next')?.addEventListener('click', () => goTo(current + 1));
    let touchStartX = 0;
    side.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    side.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(current + (diff > 0 ? 1 : -1));
    }, { passive: true });
  }

  // Quantity selector. data-min is the product minimum less whatever is already in the cart.
  product.querySelector('.product__actions')?.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty-selector__btn');
    if (!btn) return;
    const selector = btn.closest('.qty-selector');
    const valueEl  = selector.querySelector('.qty-selector__value');
    const input    = selector.querySelector('.qty-selector__input');
    const min      = parseInt(selector.dataset.min || '1', 10);
    let qty = parseInt(valueEl.textContent, 10);
    qty = btn.classList.contains('qty-selector__btn--decrease') ? Math.max(min, qty - 1) : qty + 1;
    valueEl.textContent = qty;
    if (input) input.value = qty;
    selector.querySelector('.qty-selector__btn--decrease').disabled = qty <= min;
  });

  // Backstop in case the quantity is lowered some other way than the buttons
  product.querySelector('form[action*="/cart/add"]')?.addEventListener('submit', (e) => {
    const selector = product.querySelector('.product__actions .qty-selector');
    const min = parseInt(selector?.dataset.min || '1', 10);
    const qty = parseInt(selector?.querySelector('.qty-selector__input')?.value || '1', 10);
    if (qty < min) {
      e.preventDefault();
      alert(`Du måste lägga till minst ${min} st av denna produkt.`);
    }
  });

  // Variants
  const variantsEl = product.querySelector('#product-variants-json');
  if (variantsEl) {
    const variants     = JSON.parse(variantsEl.textContent);
    const optionGroups = product.querySelectorAll('.product__option-buttons');
    const variantInput = product.querySelector('#product-variant-id');
    const priceEl      = product.querySelector('.product__price strong');

    const updateVariant = () => {
      const chosen = Array.from(optionGroups).map(g => g.querySelector('.product__option-btn--active')?.dataset.value);
      const match  = variants.find(v => v.options.every((opt, i) => opt === chosen[i]));
      if (!match) return;
      variantInput.value = match.id;
      if (priceEl) priceEl.textContent = (match.price / 100).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
      const addBtn = product.querySelector('.product__add-to-cart');
      if (addBtn) addBtn.textContent = match.available ? 'Lägg i varukorg' : 'Slutsåld';
    };

    optionGroups.forEach(group => {
      group.addEventListener('click', e => {
        const btn = e.target.closest('.product__option-btn');
        if (!btn || btn.classList.contains('product__option-btn--active')) return;
        group.querySelectorAll('.product__option-btn').forEach(b => {
          b.classList.remove('product__option-btn--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('product__option-btn--active');
        btn.setAttribute('aria-pressed', 'true');
        updateVariant();
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
